import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import api from '@/api';
import store from '@/store/index';
export default {
  namespaced: true,
  state: {
    GameTypeList: [],
    GameTypeId: 0
  },
  actions: {
    /**
     * @description 登录初始化数据
     */
    init: function init(_ref) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
          var query;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return api.useableGameType();

                case 2:
                  query = _context.sent;

                  if (query.code) {
                    commit('setGameTypeList', query.data);
                    commit('setGameTypeId', query.data[0].id);
                    dispatch('d2admin/db/set', {
                      dbName: 'sys',
                      path: 'init.GameTypeList',
                      value: query.data,
                      user: false
                    }, {
                      root: true
                    });
                    dispatch('d2admin/db/set', {
                      dbName: 'sys',
                      path: 'init.GameTypeId',
                      value: query.data[0].id,
                      user: false
                    }, {
                      root: true
                    });
                  }

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    setTypeId: function setTypeId(_ref3, id) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch,
          commit = _ref3.commit;
      state.GameTypeId = id;
      dispatch('d2admin/db/set', {
        dbName: 'sys',
        path: 'init.GameTypeId',
        value: id,
        user: false
      }, {
        root: true
      });
    },

    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    load: function load(_ref4) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var state, dispatch;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = _ref4.state, dispatch = _ref4.dispatch;
                _context2.next = 3;
                return dispatch('d2admin/db/get', {
                  dbName: 'sys',
                  path: 'init.GameTypeList',
                  defaultValue: {},
                  user: false
                }, {
                  root: true
                });

              case 3:
                state.GameTypeList = _context2.sent;
                _context2.next = 6;
                return dispatch('d2admin/db/get', {
                  dbName: 'sys',
                  path: 'init.GameTypeId',
                  defaultValue: {},
                  user: false
                }, {
                  root: true
                });

              case 6:
                state.GameTypeId = _context2.sent;

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mutations: {
    /**
     * @description 设置全局游戏类型
     */
    setGameTypeList: function setGameTypeList(state, data) {
      state.GameTypeList = data;
    },

    /**
     * @description 设置当前选择的全局游戏类型
     */
    setGameTypeId: function setGameTypeId(state, data) {
      state.GameTypeId = data;
    }
  }
};